import React from 'react';
import { Container } from '@mui/material';
import { IUniformStepContainerProps } from './interfaces';

export function UniformStepContainer(props: IUniformStepContainerProps) {
  const { children, viewEditMode = false, ...rest } = props;

  React.useLayoutEffect(() => {
    if (viewEditMode) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      sx={{
        p: 2,
        '.ViewEditMode &': {
          maxWidth: 'unset',
          p: 0,
        },
      }}
      {...rest}
    >
      {children}
    </Container>
  );
}
